import { logToTealium } from 'src/ConsentManagement/Logging/TealiumEventService';

export const log = (title: string, error?: Error): void => {
  console.error('Error: ' + title);

  const errorInformation: { [name: string]: string } = {
    'error.title': title,
    'error.name': error ? error.name : '',
    'error.stack': error ? error.stack : '',
    'error.message': error ? error.message : '',
  };

  if (!!error) {
    for (const [key, value] of Object.entries(error)) {
      errorInformation['error.' + key] = convertToString(value);
    }
  }

  return logToTealium('ConsentManagerError', errorInformation, 'stepstone-uk');
};

const convertToString = (value: any): string => {
  return typeof value == 'object' ? JSON.stringify(value) : String(value);
};
